export default {
    title: "Sondaggio inviato",
    header: "@:views.survey.submitted.title",
    message: "Grazie per il tuo feedback.",
}